import api from './api';

export const tupoksiService = {
    // PUBLIC
    getPublicTupoksi: async () => {
        try {
            const response = await api.get('/tupoksi');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // ADMIN
    getTupoksiList: async (params = {}) => {
        try {
            const response = await api.get('/tupoksi-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getTupoksi: async (id) => {
        try {
            const response = await api.get(`/tupoksi-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    createTupoksi: async (data) => {
        try {
            const response = await api.post('/tupoksi-admin', data);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    updateTupoksi: async (id, data) => {
        try {
            const response = await api.put(`/tupoksi-admin/${id}`, data);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    deleteTupoksi: async (id) => {
        try {
            const response = await api.delete(`/tupoksi-admin/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    updateStatus: async (id, status) => {
        try {
            const response = await api.post(`/tupoksi-admin/${id}/status`, { status });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },
};